/* global translate */
import React from 'react'
import './poll_list_member.css';
const { rxaget, stringToColour, rxChangeSlug, subString ,changeColorSVG } = global.rootRequire('classes/ulti')
const { checkNameContact, checkNameUser, changeColorAva } = global.rootRequire('classes/chat')

export const renderComponent = (vm) =>
<div className='zpopupPool'>
  <div className='zpopupPool_bg'></div>
  <div className='zpopupPool_main'>
    <div className='zpopupPool_center'>
      <div className='zpopupPool_center_bg zpopupPool_bg_sticky'>
        <div className='zpopupPool-header'>
          <div className='zlistpoll-close'> 
            <img className='choose_leader_icon_close filter_img_class' alt='' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} onClick={e => vm.props.closePollItemPopup()} />
          </div>
          <div className='zpopupPool-title'>{translate('Vote details')}</div>
            
        </div>
        <div className='zpollmem-header'>
          {
            vm.state.xPercent < 0 &&
            <div className='zlistpoll-pre-emoji' onClick={(e) => vm.clickMoveTab('prev')}>
              <i className="emoji_arrow_back"></i>
            </div>
          }

          <div className='zpollmem-option-list' style={{transform: `translateX(${vm.state.xPercent || 0}px)`}}>
            {
              vm.state.pollInfo.answers.map((ele,index)=>
                <div className={vm.state.answer_selected.id === ele.id ?'zpollmem-option zpollmem-option-active':'zpollmem-option'} key={ele.id}> 
                  <div className='zpollmem-option-txt-place'>
                    <div className='zpollmem-option-txt' onClick={()=>{vm.chooseAnswer(ele)}}>{ele.answer}</div>
                    <div className='zpollmem-option-txt-count'>{'(' + ele.users.length + ')'}</div>
                  </div>
                  {
                    vm.state.answer_selected.id === ele.id &&
                    <div className='zpollmem-option-border'></div>
                  }
                </div>
              )
            }
          </div>
          { 
            ((vm.state.xPercent*-1 +300) < (vm.state.slickTrackLength) )&&
            <div className='zlistpoll-next-emoji' onClick={(e) => vm.clickMoveTab('next')}>
              <i className="emoji_arrow_next"></i>
              {console.log((vm.state.xPercent*-1 +300) , (vm.state.slickTrackLength))}
            </div>
          }

        </div>
        <div className='zpollmem-list-user'>
          {
            vm.state.answer_selected &&
            vm.state.answer_selected.users &&
            vm.state.answer_selected.users.length >0 &&
            vm.state.answer_selected.users.map(ele=>{
              let member = vm.state.listMember[ele.Id] 
              return(
                <div key={ele.Id}>
                {     
                  member &&
                  <div className='group_contacts_item clearfix' >
                    <div className='zgroup_avatar'>
                      {member.profile_url && (
                        <img src={global.rxu.config.cdn_endpoint + member.profile_url} alt=''
                          data-id={'userava' + member.id} className='ava-useravatar images-static'
                          onError={e => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}
                        />
                      )}
                      {!member.profile_url && <span className='ava-span' style={{ background: `${changeColorAva(member?.id?.toString())}` }} >
                        {rxChangeSlug(checkNameUser(member)).slice(0, 2).toUpperCase()}
                      </span>}
                    </div>
                    <div className='zgroup_maininfo-contact'>
                      {(member.group_fullname.length > 35) && <div className='newgroup_userinfo_place' username-tooltip-position='right' username-tooltip={member.group_fullname}> {subString(member.group_fullname, 35)}  </div>} 
                      {(member.group_fullname.length <= 35) && <div className='newgroup_userinfo_place'> {member.group_fullname} </div>} 
                    </div>
                    <div className='newgroup_divider'></div>
                  </div>
                }
                </div>
              )
            })
          }
          
        </div>
      </div>
    </div>
  </div>
</div>

